(function () {
  "use strict";

  function wheel(cx, cy, r, sw) {
    return '<g><circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + (sw ? "none" : "#2b2b2b") + '"' + (sw ? ' stroke="#2b2b2b" stroke-width="' + sw + '"' : "") + "/>" +
      '<line x1="' + cx + '" y1="' + (cy - r + 2) + '" x2="' + cx + '" y2="' + (cy + r - 2) + '" stroke="#c9c9c9" stroke-width="2"/>' +
      '<line x1="' + (cx - r + 2) + '" y1="' + cy + '" x2="' + (cx + r - 2) + '" y2="' + cy + '" stroke="#c9c9c9" stroke-width="2"/>' +
      '<animateTransform attributeName="transform" type="rotate" from="0 ' + cx + " " + cy + '" to="-360 ' + cx + " " + cy + '" dur="0.5s" repeatCount="indefinite"/></g>';
  }

  var VEH = {
    truck: '<svg width="52" height="30" viewBox="0 0 92 52" aria-hidden="true"><rect class="rsb-tbody" x="34" y="10" width="50" height="30" rx="4"/><path class="rsb-tbody" d="M34 40 V18 H20 L8 30 V40 Z"/><rect x="12" y="22" width="12" height="9" rx="2" fill="#fff" opacity=".85"/>' + wheel(26, 42, 8) + wheel(70, 42, 8) + "</svg>",
    van: '<svg width="50" height="30" viewBox="0 0 90 52" aria-hidden="true"><path class="rsb-tbody" d="M10 40 V22 Q14 12 30 12 H80 V40 Z"/><rect x="16" y="18" width="16" height="11" rx="2" fill="#fff" opacity=".85"/>' + wheel(28, 42, 8) + wheel(66, 42, 8) + "</svg>",
    bike: '<svg width="58" height="32" viewBox="0 0 100 56" aria-hidden="true"><rect class="rsb-tbody" x="60" y="6" width="30" height="24" rx="3"/><rect x="65" y="11" width="20" height="6" rx="1" fill="#fff" opacity=".7"/><path fill="#3f3f46" d="M20 46 C17 36 17 27 24 23 L34 23 C39 23 41 26 43 30 L56 30 C63 30 66 34 66 42 L66 46 Z"/><path fill="#26262b" d="M40 27 L62 27 C65 27 66 29 63 31 L45 31 C41 31 38 29 40 27 Z"/><path fill="none" stroke="#3f3f46" stroke-width="3.5" stroke-linecap="round" d="M24 23 L19 12 M19 12 L28 12"/><circle cx="17" cy="27" r="3.5" fill="#ffe07a"/>' + wheel(26, 47, 10, 5) + wheel(76, 47, 10, 5) + "</svg>",
    plane: '<svg width="60" height="34" viewBox="0 0 104 56" aria-hidden="true"><path fill="#2f2f36" d="M46 34 L60 50 L70 50 L56 34 Z"/><path class="rsb-tbody" d="M72 27 L86 12 L90 27 Z"/><path class="rsb-tbody" d="M14 26 C7 26 7 38 14 38 L76 37 C84 36 90 33 90 32 C90 31 84 28 76 27 Z"/><circle cx="30" cy="32" r="2" fill="#fff" opacity=".85"/><circle cx="39" cy="32" r="2" fill="#fff" opacity=".85"/><circle cx="48" cy="32" r="2" fill="#fff" opacity=".85"/><circle cx="57" cy="32" r="2" fill="#fff" opacity=".85"/><circle cx="12" cy="32" r="3.5" fill="#26262b"/><g><rect x="10" y="17" width="4" height="30" rx="2" fill="#3f3f46"/><animateTransform attributeName="transform" type="rotate" from="0 12 32" to="360 12 32" dur="0.16s" repeatCount="indefinite"/></g></svg>'
  };

  var FREE = { truck: 1, van: 1, bike: 1 };
  var OFF = { truck: 60, van: 58, bike: 64, plane: 64 };
  var PALETTE = ["#5bb97a", "#e8663c", "#378add", "#d4537e", "#eab308", "#7f77dd"];

  function rnd(a, b) { return a + Math.random() * (b - a); }
  function money(sym, v) { try { return sym + Math.round(v).toLocaleString(); } catch (e) { return sym + Math.round(v); } }
  function getCart() {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  function Bar(el) {
    this.el = el;
    this.threshold = parseFloat(el.dataset.threshold) || 0;
    this.sym = el.dataset.symbol || "¥";
    this.vehicle = el.dataset.vehicle || "truck";
    if (!FREE[this.vehicle] && el.dataset.plan !== "pro") this.vehicle = "truck";
    this.anim = el.dataset.animation || "shine";
    this.celeb = el.dataset.celebration || "drive";
    this.progTpl = el.dataset.progressText || "あと {remaining} で送料無料";
    this.achTpl = el.dataset.achievedText || "送料無料対象です！";
    this.q = function (s) { return el.querySelector(s); };
    this.msg = this.q(".rsb__msg");
    this.track = this.q(".rsb__track");
    this.fill = this.q(".rsb__fill");
    this.stripes = this.q(".rsb__stripes");
    this.shine = this.q(".rsb__shine");
    this.pulse = this.q(".rsb__pulse");
    this.truck = this.q(".rsb__truck");
    this.beam = this.q(".rsb__beam");
    this.bob = this.q(".rsb__bob");
    this.done = false;

    this.off = OFF[this.vehicle] || 64;
    var au = el.dataset["anim" + this.vehicle.charAt(0).toUpperCase() + this.vehicle.slice(1)];
    if (!VEH[this.vehicle] && au) {
      this.bob.innerHTML = '<img src="' + au + '" alt="" />';
      this.bob.style.animation = "none";
      var sf = this, img = this.bob.firstChild;
      img.onload = function () { sf.off = img.width + 10; sf.update(sf.last || 0); };
    } else {
      this.bob.innerHTML = VEH[this.vehicle] || VEH.truck;
    }
    this.stripes.style.display = this.anim === "stripes" ? "block" : "none";
    this.shine.style.display = this.anim === "shine" ? "block" : "none";
    this.pulse.style.display = this.anim === "pulse" ? "block" : "none";
    this.beam.style.display = this.anim === "headlight" ? "block" : "none";

    var cents = parseFloat(el.dataset.cartTotal);
    if (!isNaN(cents)) this.update(cents);
    var self = this;
    getCart().then(function (c) { if (c) self.update(c.total_price); });
  }

  Bar.prototype.update = function (totalCents) {
    this.last = totalCents;
    var yen = (totalCents || 0) / 100, thr = this.threshold;
    var progress = thr > 0 ? Math.min(100, (yen / thr) * 100) : 100;
    var remaining = Math.max(0, thr - yen), y = 100 - progress, off = this.off;
    [this.fill, this.stripes, this.shine, this.pulse].forEach(function (elm) { elm.style.left = y + "%"; elm.style.right = "0"; });
    this.truck.style.left = "max(2px, calc(" + y + "% - " + off + "px))";
    var achieved = progress >= 100;
    this.msg.textContent = achieved ? this.achTpl : this.progTpl.replace("{remaining}", money(this.sym, remaining));
    if (achieved && !this.done) { this.done = true; this.celebrate(); }
    if (!achieved) this.done = false;
  };

  Bar.prototype.celebrate = function () {
    var fx = this.celeb;
    if (!fx || fx === "none") return;
    if (fx === "confetti") return this.confetti();
    if (fx === "drive") return this.drive();
    if (fx === "glow") return this.glow();
    if (fx === "pop") return this.pop();
    if (fx === "sparkle") return this.sparkle(10, 10, 95, 30, 70, "rsb__spark");
  };

  Bar.prototype.confetti = function () {
    var host = this.el.querySelector(".rsb__inner");
    for (var i = 0; i < 40; i++) {
      var d = document.createElement("div");
      d.className = "rsb__confetti";
      d.style.left = rnd(0, 100) + "%";
      d.style.background = PALETTE[i % PALETTE.length];
      d.style.setProperty("--dx", rnd(-40, 40) + "px");
      d.style.setProperty("--rot", rnd(180, 720) + "deg");
      d.style.animationDuration = rnd(0.9, 1.5) + "s";
      d.style.animationDelay = rnd(0, 0.25) + "s";
      host.appendChild(d);
    }
    setTimeout(function () { host.querySelectorAll(".rsb__confetti").forEach(function (e) { e.remove(); }); }, 2000);
  };

  Bar.prototype.drive = function () {
    var tw = this.truck, self = this;
    tw.style.transition = "none";
    tw.style.transform = "translate(560px,-50%)";
    void tw.offsetWidth;
    tw.style.transition = "transform 1.8s cubic-bezier(.2,.55,.25,1)";
    tw.style.transform = "translateY(-50%)";
    setTimeout(function () { tw.style.transition = "left .35s ease"; self.sparkle(9, -1, 20, 8, 92, "rsb__twk"); }, 1650);
  };

  Bar.prototype.glow = function () {
    var f = document.createElement("div");
    f.className = "rsb__flash";
    f.innerHTML = "<span></span>";
    this.track.appendChild(f);
    setTimeout(function () { f.remove(); }, 800);
  };

  Bar.prototype.pop = function () {
    var badge = this.el.querySelector(".rsb__badge");
    if (!badge) return this.sparkle(9, -1, 20, 8, 92, "rsb__twk");
    var r = document.createElement("div");
    r.className = "rsb__rip";
    badge.style.position = "relative";
    badge.appendChild(r);
    setTimeout(function () { r.remove(); }, 750);
  };

  Bar.prototype.sparkle = function (n, lmin, lmax, tmin, tmax, cls) {
    var host = this.el.querySelector(".rsb__inner"), star = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="#f5c451"><path d="M12 2l2.2 6.6L21 9l-5 4.3L17.5 21 12 17l-5.5 4L8 13.3 3 9l6.8-.4z"/></svg>';
    for (var i = 0; i < n; i++) {
      var s = document.createElement("div");
      s.className = cls;
      s.innerHTML = star;
      s.style.left = rnd(lmin, lmax) + "%";
      s.style.top = rnd(tmin, tmax) + "%";
      s.style.fontSize = rnd(13, 22) + "px";
      s.style.animationDelay = rnd(0, 0.4) + "s";
      host.appendChild(s);
    }
    setTimeout(function () { host.querySelectorAll("." + cls).forEach(function (e) { e.remove(); }); }, 1600);
  };

  var bars = [];
  function init() {
    document.querySelectorAll(".rsb").forEach(function (el) {
      if (el.__rsb) return;
      el.__rsb = true;
      bars.push(new Bar(el));
    });
  }
  function refresh() { getCart().then(function (c) { if (c) bars.forEach(function (b) { b.update(c.total_price); }); }); }

  var CART_RE = /\/cart\/(add|change|update|clear)/;
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var p = _fetch.apply(this, arguments);
      try {
        var url = arguments[0] && (arguments[0].url || arguments[0]);
        if (typeof url === "string" && CART_RE.test(url)) p.then(function () { setTimeout(refresh, 60); });
      } catch (e) {}
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (typeof url === "string" && CART_RE.test(url)) this.addEventListener("load", function () { setTimeout(refresh, 60); });
    return _open.apply(this, arguments);
  };
  document.addEventListener("cart:updated", refresh);
  document.addEventListener("cart:refresh", refresh);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
